import styled from 'styled-components'

export default styled.div`
	.pagination {
		display: flex;
		justify-content: center;
		margin: 30px 0;
		padding: 0;
		&__item {
			margin: 0 3px;
			width: 50px;
			height: 50px;
			cursor: pointer;
			&-link {
				width: 100%;
				height: 100%;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid #dee2e6;
				border-radius: 6px;
				color: #333;
				transition: border-color 0.3s, background-color 0.3s, color 0.3s;
				&:hover {
					border-color: #ff7d55 !important;
					color: #ff7d55;
					background: #fff;
				}
			}
			&.active {
				.pagination__item-link {
					color: #fff;
					background-color: #005aff;

					&:hover {
						border: 1px solid #005aff;
					}
				}
			}
			&.disabled {
				.pagination__item-link {
					color: #ccc;
				}
			}
		}
		@media (max-width: 991px) {
			margin: 0 5px;
			&__item {
				margin: 0 2px;
				width: 40px;
				height: 40px;
			}
		}
	}
`
